import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import { skillNames } from '../utils';

export default function SkillSelect({ skillId, switchSkill }) {
    const [open, setOpen] = React.useState(false);

    const [selectSelectedSkill, setSkill] = React.useState(skillId);

    const handleChange = (event) => {
        setSkill(event.target.value);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            switchSkill(selectSelectedSkill);
            setOpen(false);
        }
    };

    const handleCancel = (event, reason) => {
        // reset to old value
        setSkill(skillId);
        setOpen(false);
    }

    return (
        <Box component="div" sx={{ display: 'inline' }}>
            <Button onClick={handleClickOpen}>Module</Button>
            <Dialog disableEscapeKeyDown open={open} onClose={handleClose}>
                <DialogTitle>Wissel van module</DialogTitle>
                <DialogContent>
                    <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap' }}>
                        <FormControl sx={{ m: 1, minWidth: 120 }}>
                            <InputLabel id="demo-simple-select-label">Module</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectSelectedSkill}
                                onChange={handleChange}
                                label="Module"
                            >
                                {
                                    skillNames().map((s, i) => (
                                        <MenuItem key={'sel_' + s} value={s}>{s}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancel}>Cancel</Button>
                    <Button onClick={handleClose}>Ok</Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}